import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import LimitUpsellDialog from '@/components/billing/LimitUpsellDialog';

type LiveRolesUsageBannerProps = {
  max: number | null;
  presentersCount: number;
  guestsCount: number;
};

export default function LiveRolesUsageBanner({
  max,
  presentersCount,
  guestsCount,
}: LiveRolesUsageBannerProps) {
  const { t } = useTranslation('createWebinar');

  if (max == null) return null;

  const current = presentersCount + guestsCount;
  const atMax = current >= max;
  const percentage = Math.min(100, Math.round((current / max) * 100));

  return (
    <div
      className={cn(
        'flex gap-3 rounded-lg border-2 p-4',
        atMax ? 'bg-warning-light/50 border-warning/50' : 'bg-primary/5 border-primary/30',
      )}
    >
      <div className="flex w-full flex-col gap-2">
        <p className="text-base font-medium">{t('liveRolesLimit.usageTitle', { current, max })}</p>
        <p className="text-sm text-secondary">
          {t('liveRolesLimit.usageBreakdown', {
            presenters: presentersCount,
            guests: guestsCount,
          })}
        </p>
        <div className="h-2 w-full overflow-hidden rounded-full bg-white/80">
          <div
            className={cn(
              'h-full rounded-full transition-all',
              atMax ? 'bg-warning' : 'bg-primary',
            )}
            style={{ width: `${percentage}%` }}
          />
        </div>
        {atMax && (
          <div className="flex items-center justify-between gap-2 pt-1">
            <p className="text-sm">{t('liveRolesLimit.limitReached')}</p>
            <LimitUpsellDialog />
          </div>
        )}
      </div>
    </div>
  );
}
